import FullWidth from '../../../commonSub/component/FullWidth';
import {REGION} from '../../constant';
import Anchor from '../Anchor';
import EllipsisText from '../EllipsisText';
import PageImage from '../PageImage';
import SingleText from '../SingleText';

interface IProps {
  thumbImg: string;
  landingUri: string;
  bgColor: string;
  title: string;
  subTitle?: string;
  decorationImg?: string;
}

export default function SpecialBanner({
  thumbImg,
  landingUri,
  bgColor,
  title,
  decorationImg,
  subTitle = '',
}: IProps) {
  const isKorea = REGION === 'kor';
  return (
    <Anchor pageInfo={landingUri}>
      <FullWidth
        className="relative overflow-hidden"
        style={{background: bgColor}}
      >
        <div className="flex left-1/2 -translate-x-1/2 w-[630px] relative">
          {decorationImg && (
            <PageImage
              className={IMAGE_CN}
              pictureClassName="w-full absolute"
              src={decorationImg}
              alt=""
            />
          )}
          <PageImage
            className={IMAGE_CN}
            pictureClassName="w-full relative"
            src={thumbImg}
            alt=""
          />
        </div>
        <div
          className={cn(
            'left-1/2 top-0 -translate-x-1/2 w-[240px]',
            'absolute text-center'
          )}
        >
          <EllipsisText
            className={cn(
              's26-bold-white',
              'tracking-[-0.6px] leading-38 mt-51'
            )}
            line={isKorea ? 3 : 4}
          >
            {title}
          </EllipsisText>
          <SingleText
            width-="240px"
            className={cn(
              's16-regular-white',
              'tracking-[-0.6px] leading-20 mt-13'
            )}
          >
            {subTitle}
          </SingleText>
        </div>
      </FullWidth>
    </Anchor>
  );
}

const IMAGE_CN = 'h-[640px] block mx-auto';
